import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Box from "@material-ui/core/Box";
import { dataService } from "../../Services/data/data.service";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { competences as competencesConfig, workflowStepStatusses } from "../../Config/constants";
import { cp } from "fs";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DoneIcon from '@mui/icons-material/Done';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export const PickingOverview = (props) => {
  /* Hooks section start */
  const { t } = useTranslation();

  const [active, setActive] = useState(false);
  const [headerUserInfo, setHeaderUserInfo] = useState(null);
  const [userPermissions, setUserPermissions] = useState(null);
  const [plannedData, setPlannedData] = useState([]);
  const [getAllPausedData, setgetAllPausedData] = useState([]);
  const [open, setOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [superView, setSuperView] = useState(false);
  const [popupEnable, setPopupEnable] = useState(true);
  const [useEffectLoaded, setUseEffectLoaded] = useState(false);


  let history = useHistory();
  let tempArr = [];
  let permissionFlag = false;
  useEffect(() => {
    let userId = props.user.userInfo.sub;
    dataService.getUserById(userId).then((users) => {
      if (users.length > 0 && users[0] !== undefined && users[0] !== null) {
        setHeaderUserInfo(users[0]);
        if (handleCurrentLanguageId(props.i18n.language) !== users[0].languageId) {
          handleLanguageId(users[0].languageId);
        }
      }
    }).catch((error) => {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
    });

    dataService.getCompetencesByUser(userId).then((competences) => {
      let competencesIds = [];
      if (competences.length > 0) {
        competencesIds = competences.map((x) => {
          if (x.id === competencesConfig.PICKING) {
            setActive(true)
            permissionFlag = true;
            if (props.user.isOperator) {
              dataService.getPlanned(1).then((workflows) => {
                setPopupEnable(true);
                setPlannedData(workflows ? workflows : []);
              }).catch((error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER });
              });
            } else if (props.user.isPloegchef || props.user.isAdministrator) {
              dataService.getAllPlanned().then((workflows) => {
                setPopupEnable(false);
                setPlannedData(workflows ? workflows : []);
              }).catch((error) => {
                toast.error(error, { position: toast.POSITION.TOP_CENTER });
              });
            }
            dataService.getAllPaused().then((pausedWorkFlows) => {
              // getAllPaused(stations)
              setgetAllPausedData(pausedWorkFlows ? pausedWorkFlows : []);
            }).catch((error) => {
              toast.error(error, { position: toast.POSITION.TOP_CENTER });
            });


          }
        });
      }
      setUseEffectLoaded(true);
    }).catch((error) => {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
    });

  }, [props]);

  const handleCurrentLanguageId = (name) => {
    var id;
    switch (name) {
      case 'nl':
        id = 1;
        break;
      case 'fr':
        id = 2;
        break;
      case 'en':
        id = 3;
        break;
      case 'po':
        id = 4;
        break;
      case 'ua':
        id = 5;
        break;
      case 'de':
        id = 6;
        break;
    }
    return id;

  }

  const handleLanguageId = (id) => {
    console.log('i18n: ', props.i18n)
    switch (id) {
      case 1:
        console.log('Language Id: ', id, ' -->  nl')
        props.i18n.changeLanguage('nl');
        break;
      case 2:
        console.log('Language Id: ', id, ' -->  fr')
        props.i18n.changeLanguage('fr');
        break;
      case 3:
        console.log('Language Id: ', id, ' -->  en')
        props.i18n.changeLanguage('en');
        break;
      case 4:
        console.log('Language Id: ', id, ' -->  po')
        props.i18n.changeLanguage('po');
        break;
      case 5:
        console.log('Language Id: ', id, ' -->  ua')
        props.i18n.changeLanguage('ua');
        break;
      case 6:
        console.log('Language Id: ', id, ' -->  de')
        props.i18n.changeLanguage('de');
        break;

    }
    return props.i18n.language;
  }
  /* Hooks section end */

  /* To open dialog*/
  const handleClickOpen = () => {
    // setOpen(true);
  };

  /* To close dialog*/
  const handleClose = () => {
    setOpen(false);
  };

  /* To fetch data */
  const getStartedOrPlannedData = () => {
    setSuperView(false);
    dataService.getStartedOrPlanned(1).then((stations) => {
      setPlannedData(stations);
      setPopupEnable(true);
    }).catch((error) => {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
    });
  };

  /* To navigate to picking detail screen*/
  const goToPickingDetail = (id) => {
    
    dataService.GetPickingDetail(id).then((workflow) => {
    var thisPausedItem = workflow;
    let metaData = JSON.parse(thisPausedItem.workflowSteps[0].metaData);
    let cartNumber = metaData[0].MetaData[0].CartNumber;
    var workflowStepDetails = thisPausedItem.workflowSteps[0].workflowStepDetails;
    workflowStepDetails = workflowStepDetails.sort((a, b) => a.id - b.id);
    thisPausedItem.workflowSteps[0].workflowStepDetails = workflowStepDetails;
    var tempArr = [];
    thisPausedItem.workflowSteps[0].workflowStepDetails.map(x => {
      tempArr.push(x.finishedOn !== null ? true : false);
    });

    if (cartNumber !== null) {
      history.push({
        pathname: "/PickingDetail",
        state: {
          pausedDetailList: getAllPausedData,
          listDetail: thisPausedItem,
          tempArr: tempArr,
        },
      });
    } else {
      history.push({
        pathname: "/scannerpage",
        state: {
          pausedDetailList: getAllPausedData,
          listDetail: thisPausedItem,
          tempArr: toCheckBoxes(thisPausedItem.workflowSteps[0].workflowStepDetails.length),
        },
      });
    }
  }).catch((error) => {
    toast.error(error, { position: toast.POSITION.TOP_CENTER });
  });
  };

  /* To navigate to scanner screen*/
  const goToScanner = (id) => {
    dataService.GetScannerDetail(id).then((workflow) => {
      var thisPickingItem = workflow;
      var workflowStepDetails = thisPickingItem.workflowSteps[0].workflowStepDetails;
      workflowStepDetails = workflowStepDetails.sort((a, b) => a.id - b.id);
      thisPickingItem.workflowSteps[0].workflowStepDetails = workflowStepDetails;
      history.push({
        pathname: "/scannerpage",
        state: {
          pausedDetailList: getAllPausedData,
          listDetail: thisPickingItem,
          tempArr: toCheckBoxes(thisPickingItem.workflowSteps[0].workflowStepDetails.length),
        },
      });
    }).catch((error) => {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
    });
  };

  /*Submit*/
  let handleSubmit = async (e) => {
    e.preventDefault();
    handleClose();
    dataService
      .sendValidateUser(userName, password)
      .then((stations) => {
        setSuperView(stations);
        if (stations) {
          dataService
            .getAllStartedOrPlanned()
            .then((stations) => {
              setPlannedData(stations);
              setPopupEnable(false);
            })
            .catch((error) => {
              toast.error(error, { position: toast.POSITION.TOP_CENTER });
            });
        }
      })
      .catch((error) => {
        toast.error(error, { position: toast.POSITION.TOP_CENTER });
      });
  };

  const toCheckBoxes = (listLength) => {
    var tempArr = [];
    for (let i = 0; i < listLength; i++) {
      tempArr.push(false);
    }
    return tempArr;
  };

  const displayStatusIcon = (id) => {
    switch (id) {
      case workflowStepStatusses.Planned:
        return <QueryBuilderIcon style={{ fontSize: '35px' }}></QueryBuilderIcon>;
      case workflowStepStatusses.Started:
        return <PlayArrowIcon style={{ color: '#5CC958', fontSize: '35px' }}></PlayArrowIcon>;

      case workflowStepStatusses.Paused:
        return <PauseIcon style={{ color: '#F59127', fontSize: '35px' }}></PauseIcon>;

      case workflowStepStatusses.Done:
        return <DoneIcon style={{ color: '#5CC958', fontSize: '35px' }}></DoneIcon>;

      default:
        return <QueryBuilderIcon style={{ fontSize: '35px' }}></QueryBuilderIcon>;
    }
  }

  const showPausedList = () => {
    return getAllPausedData?.map((x, pausedIndex) => {
      return (<React.Fragment key={"reactFragmentPausedKey_" + pausedIndex}>
        <tr key={"tableRowPausedKey_" + pausedIndex}>
          <td>{displayStatusIcon(x.stepStatusId)}</td>

          <td>{x.cartNumber}</td>
          <td style={{ wordBreak: 'break-all' }}>{x.reference} - {x.itemNumber} </td>
          <td>
            <button
              className="btn-blue"
              onClick={() => goToPickingDetail(x.id)}
            >
              {t('Wijzig')}
            </button>
          </td>
        </tr>
      </React.Fragment>
      )
    })

  }

  return <React.Fragment>
    {useEffectLoaded ?
      (<React.Fragment>
        {active ? (
          <React.Fragment>
            <Box
              display="flex"
              flexDirection="column"
              flexGrow="1"
              style={{ paddingBottom: "50px" }}
            >
              <div className="section" style={{ width: '100%', maxWidth: '100%' }}>
                <h4
                  className="heading"
                  style={{ marginBottom: '18px', paddingLeft: '10px', paddingRight: '10px' }}
                >
                  {t('Overzicht nieuwe picking lijsten')}
                </h4>

                <div className="scroller">
                  <table className="table">
                    <thead  >
                      <tr onClick={(event) => (popupEnable ? handleClickOpen() : false)}
                      >
                        <th>{t('Picking lijst')}</th>
                        <th style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                          {t('Actie')}{" "}
                          <div onClick={(event) => getStartedOrPlannedData()}>
                            {superView ? <ExpandLessIcon /> : null}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {plannedData?.map((x, index) => (
                        <tr key={'plannedData_' + index}>
                          <td style={{ wordBreak: 'break-all' }}>{x.reference} - {x.itemNumber}</td>
                          <td>
                            <button
                              className="btn-blue"
                              onClick={() => goToScanner(x.id)}
                            >
                              
                              {t('Wijzig')}
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="section">
                <h4 className="heading" style={{ marginBottom: '18px', paddingLeft: '10px', paddingRight: '10px' }}>
                  {t('Overzicht wachtende picking lijsten')}</h4>
                <div className="scroller">
                  <table className="table" style={{ width: '100%', maxWidth: '100%' }}>
                    <thead>
                      <tr>
                        <th>{t('Status')}</th>
                        <th>{t('Kar')}</th>
                        <th>{t('Picking lijst')}</th>
                        <th>{t('Actie')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {showPausedList()}
                    </tbody>
                  </table>
                </div>
                <Box px={2} className="footer">
                  <Button
                    variant="contained"
                    size="large"
                    className="btn-blue"
                    onClick={() => history.push("/logout")}
                    style={{ padding: '8px 80px', borderRadius: '8px' }}
                  >
                    {t('Afmelden')}
                  </Button>
                </Box>
              </div>
            </Box>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle id="alert-dialog-title">{"Login"}</DialogTitle>
              <DialogContent>
                <Box mb={3}>
                  <TextField
                    id="standard-basic"
                    fullWidth
                    label="User Name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </Box>
                <Box mb={3}>
                  <TextField
                    id="standard-basic"
                    fullWidth
                    type="password"
                    label="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Box>
                <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                  <Box pb={2} px={2}>
                    <button style={{ marginRight: '10px' }}
                      onClick={handleClose}
                      variant="contained"
                      className="btn-blue"
                    >
                      {t('Cancel')}
                    </button>
                    <button
                      onClick={handleSubmit}
                      type="submit"
                      variant="contained"
                      className="btn-blue"
                    >
                      {t('Login')}
                    </button>
                  </Box>
                </DialogActions>
              </DialogContent>
            </Dialog>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div>
              <h1 style={{
                padding: '180px 60px',
                color: 'red'
              }}>{t('This device is to be used exclusively for the Picking process')}. </h1>
            </div>
            <Box px={2} className="footer">
              <Button
                variant="contained"
                size="large"
                className="btn-blue"
                onClick={() => history.push("/logout")}
                style={{ padding: '8px 80px', borderRadius: '8px' }}
              >
                {t('Afmelden')}
              </Button>
            </Box>
          </React.Fragment>
        )} </React.Fragment>)
      : <React.Fragment></React.Fragment>}
  </React.Fragment>
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
export default connect(mapStateToProps)(PickingOverview);
